import { absolutePath } from "../../../absolutePath";

export const paywallCheckoutAttempt = {
  // show looks up by Stripe fingerprint string (e.g. "pi_xxx") -- routed as :id
  show: (fingerprint: string) =>
    absolutePath(`paywalls/checkout/attempts/${fingerprint}`),
  // destroy looks up by numeric DB id -- same URL shape
  destroy: (attemptId: number) =>
    absolutePath(`paywalls/checkout/attempts/${attemptId}`),
};
